import apiClient from "../utilities/apiService";
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Fetch dietary preferences
export const fetchDietaryPreferencesDet = async (
  page = 0,
  size = 10,
  sort = "name,asc"
) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/diets`, {
      params: { page, size, sort },
    });
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};

// Fetch cuisines
export const fetchCuisinesDet = async (
  page = 0,
  size = 10,
  sort = "name,asc"
) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/cuisines`, {
      params: { page, size, sort },
    });
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};

// Fetch categories
export const fetchCategoriesDet = async (
  page = 0,
  size = 10,
  sort = "name,asc"
) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/categories`, {
      params: { page, size, sort },
    });
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const deleteItem = async (section, id) => {
  try {
    let endpoint = "";

    switch (section) {
      case "Dietary Preference":
        endpoint = `${BASE_URL}/diets/${id}`;
        break;
      case "Cuisine":
        endpoint = `${BASE_URL}/cuisines/${id}`;
        break;
      case "Category":
        endpoint = `${BASE_URL}/categories/${id}`;
        break;
      default:
        throw new Error("Invalid section name provided.");
    }

    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    console.error(`Failed to delete item in ${section}:`, error);
    throw error;
  }
};

// Add Item API (for both Dietary Preference and Cuisine)
export const addItemDeitsCuisines = async (section, name, coverPhotoId) => {
  try {
    let endpoint = "";
    switch (section) {
      case "Dietary Preference":
        endpoint = `${BASE_URL}/diets`;
        break;
      case "Cuisine":
        endpoint = `${BASE_URL}/cuisines`;
        break;
      default:
        throw new Error("Invalid section name provided.");
    }
    const payload = {
      name,
      coverPhotoId,
    };
    const response = await apiClient.post(endpoint, payload);
    return response.data;
  } catch (error) {
    console.error(`Failed to add item in ${section}:`, error);
    throw error;
  }
};

// File Upload API
export const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("resolution", "1:1");
    formData.append("fileFormat", "IMAGE");

    const response = await apiClient.post(`${BASE_URL}/files/save`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response?.data?.data?.file?.id; // Return the file ID
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

// API function to add a new category
export const addCategory = async (categoryName) => {
  try {
    const payload = { name: categoryName }; 
    const response = await apiClient.post(`${BASE_URL}/categories`, payload); 
    return response?.data;
  } catch (error) {
    console.error("Failed to add category:", error);
    throw error; 
  }
};
